import api from '../api';
import { batchUpdatePrice } from '../api';

export async function saveAllPrices(updates, sellerId) {
  return batchUpdatePrice(updates, sellerId);
}

export async function saveProductPricing(productId, sellerId, pricingData) {
  const body = {
    sellerId: Number(sellerId),
    title: pricingData.title || '',
    description: pricingData.description || '',
    category: pricingData.category || '',
    subcategory: pricingData.subcategory || '',
    sellerSku: pricingData.sellerSku || '',
    brand: pricingData.brand || '',
    color: pricingData.color || '',
    bundleId: pricingData.bundleId || null,
    groupId: pricingData.groupId || null,
    oldPrice: pricingData.oldPrice !== undefined && pricingData.oldPrice !== '' && !isNaN(Number(pricingData.oldPrice))
      ? Number(pricingData.oldPrice)
      : null,
  };
  return api.put(`/api/products/${productId}/meta`, body);
}